import { useEffect } from 'react';
import { getIn, useFormikContext } from 'formik';
export const EmailChangeHandler = ({ emailFieldKey, emailValue, skipEmailValidation, onEmailChange, setEmailStatus, }) => {
    const { errors, values, setFieldValue, setFieldError } = useFormikContext();
    const currentEmailValue = getIn(values, emailFieldKey);
    const currentEmailError = getIn(errors, emailFieldKey);
    useEffect(() => {
        currentEmailValue !== emailValue && setFieldValue(emailFieldKey, emailValue);
    }, [emailValue]);
    useEffect(() => {
        onEmailChange && onEmailChange(currentEmailValue);
    }, [currentEmailValue]);
    useEffect(() => {
        if (skipEmailValidation) {
            setFieldError(emailFieldKey, undefined);
        }
        else {
            setFieldValue(emailFieldKey, currentEmailValue); // set value to trigger validation
        }
    }, [skipEmailValidation]);
    useEffect(() => {
        if (currentEmailError && setEmailStatus) {
            setEmailStatus(currentEmailError);
        }
    }, [currentEmailError]);
    return null;
};
